// extracted by mini-css-extract-plugin
export default {"routinesBlock":"Routines_routinesBlock__fnueZ","wrapperBlock":"Routines_wrapperBlock__HXm74","container":"Routines_container__N+ein","title":"Routines_title__KtUU-"};